import { Controller } from "@hotwired/stimulus"
import { currentLocation } from "../helpers/location.js"
import { sendFilter } from "../helpers/filter.js"

export default class extends Controller {
  static targets = ['form', 'link']

  connect() {
    if (this.hasFormTarget) {
      this.formTarget.addEventListener('submit', function(e) {
        e.preventDefault()
        e.stopImmediatePropagation()
        sendFilter()
      })
    }
  }

  copy_url(event) {
    event.preventDefault()
    this.copyToClipboard(currentLocation())
    $(document).Toasts('create', {
      autohide: true,
      position: 'bottomLeft',
      delay: 3000,
      title: this.linkTarget.dataset.title,
      body: this.linkTarget.dataset.message,
      class: 'bg-success'
    })
  }

  copyToClipboard(str) {
    const el = document.createElement('textarea')
    el.value = str
    el.setAttribute('readonly', '')
    el.style.position = 'absolute'
    el.style.left = '-9999px'
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
  }

  send(e) {
    sendFilter()
  }

}
